class $306d5933915b258a$export$6191c3ac084cc81b {
    constructor(archetype, target){
        this.archetype = archetype;
        this.target = target;
    }
}


const $3011993b820701fd$export$1db4dadbdda533a3 = 'ACTION_ATTACK';
const $3011993b820701fd$export$cae6d2c3c92242c8 = 'ACTION_MOVE';
const $3011993b820701fd$export$ec52a6ec7cbb37f3 = 'ACTION_REST';
const $3011993b820701fd$export$c89d6b8b907791b2 = 11;
const $3011993b820701fd$export$eefabe5abfdf297 = 11;
const $3011993b820701fd$export$c2886a91e3a6b0e0 = 1;
const $3011993b820701fd$export$28c773646c738669 = 12;
const $3011993b820701fd$export$28a694fb106a7f62 = 'Down';
const $3011993b820701fd$export$4f1506fa80c37e6f = 'Left';
const $3011993b820701fd$export$a34043b88230a335 = 'Right';
const $3011993b820701fd$export$b5ad9376033e98b2 = 'Up';
const $3011993b820701fd$export$1437d928db3cc222 = [
    $3011993b820701fd$export$4f1506fa80c37e6f,
    $3011993b820701fd$export$a34043b88230a335,
    $3011993b820701fd$export$b5ad9376033e98b2,
    $3011993b820701fd$export$28a694fb106a7f62
];
const $3011993b820701fd$export$f1bfc66eb737a7d8 = 'ENTITY_TYPE_CHARACTER';
const $3011993b820701fd$export$72adc902a0e2da62 = 'ENTITY_TYPE_TERRAIN';
const $3011993b820701fd$export$1e8f39e249d92158 = 0;
const $3011993b820701fd$export$19232cf1de8b5126 = 1;
const $3011993b820701fd$export$7c645dd5a0f2fa39 = 2;
const $3011993b820701fd$export$a5dd25a4ddf1d32e = 3;
const $3011993b820701fd$export$c0dd73fee55e769e = 'WEAPON_BOW';
const $3011993b820701fd$export$e4e5bb17fdf8c6d3 = 'WEAPON_CLAWS';
const $3011993b820701fd$export$c13fbe26a0de47da = 'WEAPON_SPIT';
const $3011993b820701fd$export$b6da441689e67cc3 = 'WEAPON_SWORD';


class $e725b5e12b190956$export$269dea343bcd7e48 {
    static meleeDps(isAdversary = true) {
        const combatDistance = (0, $3011993b820701fd$export$c2886a91e3a6b0e0);
        let cssImageVariable;
        if (isAdversary) cssImageVariable = 'sprite-claw';
        else cssImageVariable = 'sprite-fighter';
        return {
            combatDistance: combatDistance,
            cssImageVariable: cssImageVariable,
            label: 'Melee DPS'
        };
    }
    static rangedDps(isAdversary = true) {
        const combatDistance = (0, $3011993b820701fd$export$28c773646c738669);
        let cssImageVariable;
        if (isAdversary) cssImageVariable = 'sprite-spit';
        else cssImageVariable = 'sprite-archer';
        return {
            combatDistance: combatDistance,
            cssImageVariable: cssImageVariable,
            label: 'Ranged DPS'
        };
    }
}




class $923ef9a621e5c599$export$58ce12eb22e52a3f {
    static adjustPosition = (position, direction)=>{
        const adjusted = {
            x: position.x,
            y: position.y
        };
        switch(direction){
            case 0, $3011993b820701fd$export$28a694fb106a7f62:
                adjusted.y++;
                break;
            case 0, $3011993b820701fd$export$b5ad9376033e98b2:
                adjusted.y--;
                break;
            case 0, $3011993b820701fd$export$a34043b88230a335:
                adjusted.x++;
                break;
            case 0, $3011993b820701fd$export$4f1506fa80c37e6f:
                adjusted.x--;
                break;
        }
        return adjusted;
    };
    // as in d20, d6, etc
    static d(sides) {
        return Math.floor(Math.random() * sides) + 1;
    }
    static randomPosition = (topLeft, bottomRight)=>{
        const xDieSize = bottomRight.x - topLeft.x + 1;
        const xOffset = bottomRight.x - xDieSize;
        const yDieSize = bottomRight.y - topLeft.y + 1;
        const yOffset = bottomRight.y - yDieSize;
        // console.info("randomPosition"
        //     , xDieSize,xOffset
        //     , yDieSize,yOffset
        //     , topLeft, bottomRight
        // )
        const retval = {
            x: $923ef9a621e5c599$export$58ce12eb22e52a3f.d(xDieSize) + xOffset,
            y: $923ef9a621e5c599$export$58ce12eb22e52a3f.d(yDieSize) + yOffset
        };
        return retval;
    };
    // Fisher-Yates implementation from: https://stackoverflow.com/a/2450976
    static shuffle(deck) {
        let currentIndex = deck.length;
        // While there remain elements to shuffle...
        while(currentIndex != 0){
            // Pick a remaining element...
            let randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;
            // And swap it with the current element.
            [deck[currentIndex], deck[randomIndex]] = [
                deck[randomIndex],
                deck[currentIndex]
            ];
        }
        return deck;
    }
    static entityAtPosition = (entities, position)=>{
        if (!entities) return false;
        const found = entities.find((entity)=>{
            if (position.x === entity.position.x && position.y === entity.position.y) {
                if (entity.entityType === (0, $3011993b820701fd$export$f1bfc66eb737a7d8)) return entity.isAlive();
                return true;
            }
            return false;
        });
        if (found === undefined) return false;
        return found;
    };
    static partierAtPosition = (partiers, position)=>$923ef9a621e5c599$export$58ce12eb22e52a3f.entityAtPosition(partiers, position);
    static adversaryAtPosition = (adversaries, position)=>$923ef9a621e5c599$export$58ce12eb22e52a3f.entityAtPosition(adversaries, position);
    static terrainAtPosition = (terrain, position)=>$923ef9a621e5c599$export$58ce12eb22e52a3f.entityAtPosition(terrain, position);
    static xInBounds = (x)=>x >= 0 && x < (0, $3011993b820701fd$export$eefabe5abfdf297);
    static yInBounds = (y)=>y >= 0 && y < (0, $3011993b820701fd$export$c89d6b8b907791b2);
    static positionInBounds = (position)=>{
        return $923ef9a621e5c599$export$58ce12eb22e52a3f.xInBounds(position.x) && $923ef9a621e5c599$export$58ce12eb22e52a3f.yInBounds(position.y);
    };
    static adversaryAtPosition = (adversaries, position)=>$923ef9a621e5c599$export$58ce12eb22e52a3f.entityAtPosition(adversaries, position);
    static partierAtPosition = (partiers, position)=>$923ef9a621e5c599$export$58ce12eb22e52a3f.entityAtPosition(partiers, position);
    static terrainAtPosition = (terrain, position)=>$923ef9a621e5c599$export$58ce12eb22e52a3f.entityAtPosition(terrain, position);
}


let $219c641f94257beb$var$nextNumber = 1;
class $219c641f94257beb$export$cb68cc2163cd3f1 {
    constructor(options){
        // console.info('character.js - constructing')
        if (options.number) this.number = options.number;
        else {
            this.number = $219c641f94257beb$var$nextNumber;
            $219c641f94257beb$var$nextNumber++;
        }
        if (options.isAdversary) this.isAdversary = true;
        else this.isAdversary = false;
        this.entityType = (0, $3011993b820701fd$export$f1bfc66eb737a7d8);
        this.health = options.health ? options.health : (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).d(10);
        this.maxHealth = this.health;
        if (options.archetype) this.archetype = options.archetype;
        else {
            const roll = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).d(100);
            if (roll > 40) this.archetype = (0, $e725b5e12b190956$export$269dea343bcd7e48).meleeDps(this.isAdversary);
            else this.archetype = (0, $e725b5e12b190956$export$269dea343bcd7e48).rangedDps(this.isAdversary);
        }
        this.position = options.position ? options.position : {
            x: 0,
            y: 0
        };
        this.name = options.name ? options.name : `Character ${this.number}`;
    }
    takeDamage = (damage)=>{
        this.health -= damage;
    };
    isAlive() {
        return this.health > 0;
    }
    obfuscatedHealth() {
        const damageAsPercent = this.health / this.maxHealth;
        if (damageAsPercent <= 0) return 'DEAD';
        else if (damageAsPercent < 0.25) return 'NEAR DEATH';
        else if (damageAsPercent < 0.4) return 'BADLY HURT';
        else if (damageAsPercent < 0.7) return 'LIGHTLY WOUNDED';
        return 'HEALTHY';
    }
}


/* template
        "board": [
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
            [0,0,0,0,0,0,0,0,0,0,0],
        ]

*/ const $0b17a6f96e562f34$export$eacfd1c7ead7aedd = [
    {
        "name": "rocks in the forest",
        "board": [
            [
                1,
                1,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1
            ],
            [
                1,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1
            ],
            [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ],
            [
                0,
                0,
                0,
                2,
                2,
                0,
                2,
                2,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                2,
                0,
                0,
                0,
                2,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                2,
                0,
                0,
                0,
                2,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                2,
                2,
                0,
                2,
                2,
                0,
                0,
                0
            ],
            [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ],
            [
                1,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1
            ],
            [
                1,
                1,
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1
            ]
        ]
    },
    {
        "name": "the river",
        "board": [
            [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                2
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                3,
                3,
                0,
                0,
                0,
                3,
                3,
                3,
                0,
                0,
                0
            ],
            [
                3,
                3,
                0,
                3,
                3,
                3,
                3,
                3,
                0,
                3,
                0
            ],
            [
                0,
                0,
                0,
                0,
                3,
                3,
                0,
                0,
                0,
                0,
                3
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                1,
                2,
                0,
                0,
                0,
                0,
                0,
                2,
                1,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        ]
    },
    {
        "name": "the bay",
        "board": [
            [
                0,
                0,
                0,
                0,
                0,
                0,
                3,
                3,
                3,
                3,
                3
            ],
            [
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                3,
                3,
                3,
                3
            ],
            [
                1,
                1,
                1,
                0,
                0,
                0,
                0,
                3,
                3,
                3,
                3
            ],
            [
                2,
                2,
                1,
                0,
                0,
                0,
                0,
                3,
                3,
                3,
                3
            ],
            [
                0,
                2,
                2,
                0,
                0,
                0,
                0,
                0,
                3,
                2,
                3
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                3,
                3,
                3
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                3
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                2,
                2
            ],
            [
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                2,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]
        ]
    }
];



class $3d5623ac983b715d$export$efddd1472b012ba0 {
    static ByType(type, x, y) {
        switch(type){
            case 0:
                return $3d5623ac983b715d$export$efddd1472b012ba0.Plain(x, y);
        }
    }
    static Plain = (x, y)=>{
        return new $3d5623ac983b715d$export$efddd1472b012ba0(1, 'plain', {
            x: x,
            y: y
        }, true);
    };
    static Rock = (x, y)=>{
        return new $3d5623ac983b715d$export$efddd1472b012ba0(100, 'rock', {
            x: x,
            y: y
        }, false);
    };
    static Tree = (x, y)=>{
        return new $3d5623ac983b715d$export$efddd1472b012ba0(100, 'tree', {
            x: x,
            y: y
        }, false);
    };
    static Water = (x, y)=>{
        return new $3d5623ac983b715d$export$efddd1472b012ba0(100, `water`, {
            x: x,
            y: y
        }, true);
    };
    constructor(cost, name, position, traversibleByRanged){
        this.cost = cost;
        this.name = name;
        this.position = position;
        this.traversibleByRanged = traversibleByRanged;
        this.type = (0, $3011993b820701fd$export$72adc902a0e2da62);
    }
    isAlive() {
        return false;
    }
}




class $75fba0346ebd585c$var$State {
    allCharacters() {
        return this.adversaries.concat(this.partiers);
    }
    allPartiersAreDead() {
        return this.partiers.findIndex((partier)=>partier.isAlive()) === -1;
    }
    allAdversariesAreDead() {
        return this.adversaries.findIndex((adversary)=>adversary.isAlive()) === -1;
    }
    characterWithInitiative() {
        const characterInOrder = this.initiative.order[this.initiative.indexWithInitiative];
        return this.allCharacters().find((character)=>character.number === characterInOrder.number);
    }
    characterWithNumber(number) {
        return this.allCharacters().find((character)=>{
            return character.number === number;
        });
    }
    constructor(){
        this.action = null;
        this.adversaries = [];
        this.attacks = [];
        this.direction = null;
        this.ended = false;
        this.initiative = {
            indexWithInitiative: 0,
            order: []
        }, this.log = [];
        this.map = null;
        this.partiers = [];
        this.terrain = [];
    }
}
class $75fba0346ebd585c$export$985739bfa5723e08 {
    static mapList() {
        return 0, $0b17a6f96e562f34$export$eacfd1c7ead7aedd;
    }
    attack() {
        const character = this.state.characterWithInitiative();
        this.state.log.push(`${character.name} ATTACKED ${this.state.direction}`);
        // default to full board, reduce for melee
        let range = 12;
        if (character.archetype.combatDistance === (0, $3011993b820701fd$export$c2886a91e3a6b0e0)) range = 1;
        let adjusted = {
            x: character.position.x,
            y: character.position.y
        };
        adjusted = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).adjustPosition(adjusted, this.state.direction);
        const attackTarget = this.state.map.actions.attack.find((it)=>{
            return it.direction === this.state.direction;
        }).target;
        // starting one tile away from the character, step through each tile in `direction`
        // while still in bounds and within `range` and make an attack object 
        let distance = 1;
        while((0, $923ef9a621e5c599$export$58ce12eb22e52a3f).positionInBounds(adjusted) && distance <= range){
            if (adjusted.x === attackTarget.position.x && adjusted.y === attackTarget.position.y) distance = 10000 // break the loop after this attack
            ;
            this.state.attacks.push(new (0, $306d5933915b258a$export$6191c3ac084cc81b)(character.archetype, adjusted));
            adjusted = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).adjustPosition(adjusted, this.state.direction);
            distance++;
        }
        if ((0, $923ef9a621e5c599$export$58ce12eb22e52a3f).d(100) > 20) {
            const damage = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).d(4);
            attackTarget.takeDamage(damage);
            this.state.log.push(`${attackTarget.name} IS DAMAGED FOR ${damage} POINTS`);
            if (attackTarget.isAlive()) this.state.log.push(`${attackTarget.name} IS ${attackTarget.obfuscatedHealth()}`);
            else this.state.log.push(`${attackTarget.name} DIES`);
            return true;
        } else this.state.log.push(`${character.name} MISSED ${attackTarget.name}`);
        return false;
    }
    anythingAtPosition(position) {
        const partier = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).partierAtPosition(this.state.partiers, position);
        const adversary = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).adversaryAtPosition(this.state.adversaries, position);
        const terrain = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).terrainAtPosition(this.state.terrain, position);
        if (partier) return partier;
        if (adversary) return adversary;
        if (terrain) return terrain;
        return false;
    }
    chooseAdversaryAction() {
        // console.info('game.js - chooseAdversaryAction()')
        // By making it take a random number of tries before an action is selected
        // it makes it seem like the computer is taking time to decide
        const roll = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).d(4);
        if (roll !== 1) return;
        // if there's something to attack, attack it
        if (this.state.map.actions.attack.length > 0) {
            this.state.action = (0, $3011993b820701fd$export$1db4dadbdda533a3);
            this.state.direction = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).shuffle(this.state.map.actions.attack.map((attack)=>attack.direction)).pop();
        } else {
            this.state.action = (0, $3011993b820701fd$export$cae6d2c3c92242c8);
            this.state.direction = this.chooseAdversaryDirection(this.state.map.actions.move.map((move)=>move.direction));
        }
    }
    chooseAdversaryDirection(possibleDirections) {
        // console.log('game.js - chooseAdversaryDirection', possibleDirections)
        // get distances for each pc. huge value returned if dead so they're ignored
        const distances = this.state.partiers.map((partier, partierIndex)=>{
            const distance = partier.alive ? Math.hypot(partier.position.x - adversary.position.x, partier.position.y - adversary.position.y) : 1000;
            return {
                pcIndex: partierIndex,
                distance: distance
            };
        // then sort distances so the shortest distance is first
        }).sort((a, b)=>{
            if (a.distance < b.distance) return -1;
            if (a.distance > b.distance) return 1;
            // must be equal
            return 0;
        });
        const adversary = this.state.characterWithInitiative();
        // and figure out if one of the moves can get me closer to the
        // pcIndex of the closest pc by distance
        // todo shake chosen direction up a bit, going down first is predictable
        const firstPartier = this.state.partiers[distances[0].pcIndex];
        let log = `${adversary.name} MOVES `;
        let direction = 'no direction picked';
        if (adversary.position.y < firstPartier.position.y - 1 && possibleDirections.includes((0, $3011993b820701fd$export$28a694fb106a7f62))) {
            direction = (0, $3011993b820701fd$export$28a694fb106a7f62);
            log = `${log}${0, $3011993b820701fd$export$28a694fb106a7f62}`;
        } else if (adversary.position.y > firstPartier.position.y + 1 && possibleDirections.includes((0, $3011993b820701fd$export$b5ad9376033e98b2))) {
            direction = (0, $3011993b820701fd$export$b5ad9376033e98b2);
            log = `${log}${0, $3011993b820701fd$export$b5ad9376033e98b2}`;
        } else if (adversary.position.x < firstPartier.position.x && possibleDirections.includes((0, $3011993b820701fd$export$a34043b88230a335))) {
            direction = (0, $3011993b820701fd$export$a34043b88230a335);
            log = `${log}${0, $3011993b820701fd$export$a34043b88230a335}`;
        } else if (adversary.position.x > firstPartier.position.x && possibleDirections.includes((0, $3011993b820701fd$export$4f1506fa80c37e6f))) {
            direction = (0, $3011993b820701fd$export$4f1506fa80c37e6f);
            log = `${log}${0, $3011993b820701fd$export$4f1506fa80c37e6f}`;
        } else // something is blocking the direct path, so pick any 
        // allowed move to do something
        if (possibleDirections.length > 0) {
            const moveIndex = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).d(possibleDirections.length) - 1;
            direction = possibleDirections[moveIndex] // Utilities.adjustPosition(adversary.position, moves[moveIndex])
            ;
        } else // unless there really isn't anything that can be done
        log = `${log} nowhere. They are stuck!`;
        this.state.log.push(log);
        return direction;
    }
    constructor(settings){
        // console.info('game.js - constructor', settings)
        this.settings = settings;
        this.state = new $75fba0346ebd585c$var$State();
        this.state.log.push('Combat!');
        this.initializeMap(settings.map);
        // terrain has to come before characters so we don't put characters onto trees or rocks or water
        this.initializeTerrain(settings.terrain);
        this.initializeAdversaries(settings.adversaries);
        this.initializePartiers(settings.partiers);
        // roll initiative once characters are created
        if (this.state.initiative.order.length === 0) {
            this.state.initiative.order = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).shuffle(this.state.allCharacters()).map((character)=>{
                return {
                    isAdversary: character.isAdversary,
                    number: character.number,
                    name: character.name
                };
            });
            this.state.initiative.indexWithInitiative = 0;
        }
    }
    endGame() {
        // console.log('game.js - endGame')
        this.state.log.push('Game over!');
        this.state.map = null;
        this.state.ended = true;
    }
    endTurn() {
        this.state.action = null;
        this.state.direction = null;
        this.nextInitiative();
    }
    identifyActions() {
        // console.log('game.js - identifyInteractions') 
        const actions = {
            attack: [],
            move: [],
            rest: []
        };
        const position = this.state.characterWithInitiative().position;
        const range = this.state.characterWithInitiative().archetype.combatDistance;
        (0, $3011993b820701fd$export$1437d928db3cc222).forEach((direction)=>{
            const attackTarget = this.identifyAttackTarget(position, direction, range);
            if (attackTarget) actions.attack.push(attackTarget);
            const moveTarget = this.identifyMoveTarget(position, direction, range);
            if (moveTarget) actions.move.push(moveTarget);
            actions.rest.push({
                position: position
            });
        });
        this.state.map.actions = actions;
    }
    // exits early if there is any blocker, runs until it finds a target or is out of range or bounds
    identifyAttackTarget(startPosition, direction, range) {
        // console.log('game.js - identifyAttackTarget', startingPosition, direction)
        let adjusted = {
            x: startPosition.x,
            y: startPosition.y
        };
        adjusted = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).adjustPosition(adjusted, direction);
        // starting one tile away from the character, step through each tile in `direction`
        // while still in bounds and within `range`
        let distance = 1;
        while((0, $923ef9a621e5c599$export$58ce12eb22e52a3f).positionInBounds(adjusted) && distance <= range){
            ///// vvvvv this section might be where a callback could occur?
            const tileType = this.state.map.board[adjusted.y][adjusted.x];
            // console.log('tileType at position', tileType)
            // if there is a rock or tree at this position they block any attacks (water does not)
            if (tileType === (0, $3011993b820701fd$export$7c645dd5a0f2fa39) || tileType == (0, $3011993b820701fd$export$19232cf1de8b5126)) return false;
            // is there an opposition character at this position? 
            var target = false;
            if (this.state.characterWithInitiative().isAdversary) target = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).partierAtPosition(this.state.partiers, adjusted);
            else target = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).adversaryAtPosition(this.state.adversaries, adjusted);
            if (target) return {
                direction: direction,
                position: adjusted,
                target: target
            };
            ///// ^^^^^ this section might be where a callback could occur?
            // this tile has no character or blocking terrain, move to next tile
            adjusted = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).adjustPosition(adjusted, direction);
            distance++;
        }
        // went out of bounds or to maximum range without finding a target
        return false;
    }
    identifyMoveTarget(startPosition, direction) {
        // console.log('game.js - identifyMoveTarget', startPosition, direction)
        let adjusted = {
            x: startPosition.x,
            y: startPosition.y
        };
        adjusted = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).adjustPosition(adjusted, direction);
        // are we still on the map?
        if (!(0, $923ef9a621e5c599$export$58ce12eb22e52a3f).positionInBounds(adjusted)) return false;
        // is there is a rock or tree or water blocking us?
        if (this.state.map.board[adjusted.y][adjusted.x] != (0, $3011993b820701fd$export$1e8f39e249d92158)) return false;
        // is there a character at this position blocking us? 
        if ((0, $923ef9a621e5c599$export$58ce12eb22e52a3f).partierAtPosition(this.state.partiers, adjusted)) return false;
        if ((0, $923ef9a621e5c599$export$58ce12eb22e52a3f).adversaryAtPosition(this.state.adversaries, adjusted)) return false;
        return {
            direction: direction,
            position: adjusted
        };
    }
    initializeAdversaries(adversaries) {
        const boundary = {
            topLeft: {
                x: 0,
                y: 0
            },
            bottomRight: {
                x: 10,
                y: 4
            }
        };
        this.initializeCharacters(adversaries, this.state.adversaries, {
            isAdversary: true,
            boundary: boundary
        });
    }
    initializeCharacters(characters, collection, options) {
        // console.info('game.js - intializeCharacters', characters)
        if (Array.isArray(characters)) {
            this.characters = characters;
            return;
        }
        let count;
        if (characters === 'random') count = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).d(4);
        else count = characters;
        for(let characterIndex = 0; characterIndex < count; characterIndex++){
            options.position = this.safeSpawnPosition(options.boundary.topLeft, options.boundary.bottomRight);
            collection.push(new (0, $219c641f94257beb$export$cb68cc2163cd3f1)(options));
        }
    }
    initializeMap(map) {
        if (map === 'random') this.state.map = (0, $0b17a6f96e562f34$export$eacfd1c7ead7aedd)[(0, $923ef9a621e5c599$export$58ce12eb22e52a3f).d((0, $0b17a6f96e562f34$export$eacfd1c7ead7aedd).length) - 1];
        else this.state.map = (0, $0b17a6f96e562f34$export$eacfd1c7ead7aedd).find((mapOption)=>mapOption.name === map);
    }
    initializeTerrain() {
        const board = this.state.map.board;
        for(let y = 0; y < board.length; y++)for(let x = 0; x < board[0].length; x++)switch(board[y][x]){
            case 0, $3011993b820701fd$export$19232cf1de8b5126:
                this.state.terrain.push((0, $3d5623ac983b715d$export$efddd1472b012ba0).Tree(x, y));
                break;
            case 0, $3011993b820701fd$export$7c645dd5a0f2fa39:
                this.state.terrain.push((0, $3d5623ac983b715d$export$efddd1472b012ba0).Rock(x, y));
                break;
            case 0, $3011993b820701fd$export$a5dd25a4ddf1d32e:
                this.state.terrain.push((0, $3d5623ac983b715d$export$efddd1472b012ba0).Water(x, y));
                break;
            case 0, $3011993b820701fd$export$1e8f39e249d92158:
                break;
        }
    }
    initializePartiers(partiers) {
        const boundary = {
            topLeft: {
                x: 0,
                y: 6
            },
            bottomRight: {
                x: 10,
                y: 10
            }
        };
        this.initializeCharacters(partiers, this.state.partiers, {
            isAdversary: false,
            boundary: boundary
        });
    }
    move() {
        const character = this.state.characterWithInitiative();
        let target = {
            x: character.position.x,
            y: character.position.y
        };
        target = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).adjustPosition(character.position, this.state.direction);
        if (!(0, $923ef9a621e5c599$export$58ce12eb22e52a3f).positionInBounds(target)) {
            console.error("TRIED TO MOVE OFF BOARD put something in log");
            return false;
        }
        if (this.anythingAtPosition(target)) return false;
        character.position.x = target.x;
        character.position.y = target.y;
        return true;
    }
    nextInitiative() {
        if (this.state.allAdversariesAreDead() || this.state.allPartiersAreDead()) {
            console.log('ni');
            this.endGame();
            return;
        }
        const initiative = this.state.initiative;
        initiative.indexWithInitiative++;
        if (initiative.indexWithInitiative >= initiative.order.length) initiative.indexWithInitiative = 0;
        // skip any dead characters
        while(this.state.ended === false && !this.state.characterWithInitiative().isAlive()){
            initiative.indexWithInitiative++;
            if (initiative.indexWithInitiative >= initiative.order.length) initiative.indexWithInitiative = 0;
        }
    }
    options() {
        const options = {
            attacks: [],
            moves: []
        };
        (0, $3011993b820701fd$export$1437d928db3cc222).forEach((direction)=>{
            const attackTarget = this.targetInDirection(direction);
            if (attackTarget) options.attacks.push(direction);
            else {
                const moveTarget = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).adjustPosition(this.state.characterWithInitiative().position, direction);
                if (!this.anythingAtPosition(moveTarget) && (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).positionInBounds(moveTarget)) options.moves.push(direction);
            }
        });
        return options;
    }
    performAction() {
        // console.log('game.js - performAction', this.state.action, this.state.direction)
        const character = this.state.characterWithInitiative();
        if (this.state.action === (0, $3011993b820701fd$export$ec52a6ec7cbb37f3)) {
            this.state.log.push(`${character.name} RESTED`);
            this.endTurn();
            return;
        }
        if (this.state.action === null || this.state.direction === null) return;
        if (this.state.action === (0, $3011993b820701fd$export$1db4dadbdda533a3)) this.attack();
        if (this.state.action === (0, $3011993b820701fd$export$cae6d2c3c92242c8)) {
            this.state.log.push(`${character.name} MOVED ${this.state.direction}`);
            this.move();
        }
        // once the action is performed the character's turn ends
        this.endTurn();
    }
    safeSpawnPosition = (topLeft = {
        x: 0,
        y: 0
    }, bottomRight = {
        x: 10,
        y: 10
    }, position = null)=>{
        var potentialPosition = position ? position : (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).randomPosition(topLeft, bottomRight);
        while(this.anythingAtPosition(potentialPosition))potentialPosition = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).randomPosition(topLeft, bottomRight);
        return potentialPosition;
    };
    setAction(action) {
        this.state.action = action;
    }
    setDirection(direction) {
        this.state.direction = direction;
    }
    targetInDirection(direction) {
        const character = this.state.characterWithInitiative();
        let targetPosition = this.partierInDirection(character.position, direction);
        let blockerPosition = this.terrainInDirection(character.position, direction);
        if (!targetPosition) return false;
        const range = character.archetype.combatDistance;
        if (direction === (0, $3011993b820701fd$export$4f1506fa80c37e6f)) {
            if (blockerPosition && blockerPosition.x > targetPosition.x) return false;
            if (character.position.x - targetPosition.x > range) return false;
        }
        if (direction === (0, $3011993b820701fd$export$a34043b88230a335)) {
            if (blockerPosition.x < targetPosition.x) return false;
            if (targetPosition.x - character.position.x > range) return false;
        }
        if (direction === (0, $3011993b820701fd$export$28a694fb106a7f62)) {
            if (blockerPosition.y < targetPosition.y) return false;
            if (targetPosition.y - character.position.y > range) return false;
        }
        if (direction === (0, $3011993b820701fd$export$b5ad9376033e98b2)) {
            if (blockerPosition.y > targetPosition.y) return false;
            if (character.position.y - targetPosition.y > range) return false;
        }
        return true;
    }
    partierInDirection = (position, direction)=>{
        const range = this.state.characterWithInitiative().archetype.combatDistance;
        let adjusted = {
            x: position.x,
            y: position.y
        };
        let distance = 0;
        while((0, $923ef9a621e5c599$export$58ce12eb22e52a3f).positionInBounds(adjusted) && distance <= range){
            if ((0, $923ef9a621e5c599$export$58ce12eb22e52a3f).partierAtPosition(this.state.partiers, adjusted)) return adjusted;
            adjusted = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).adjustPosition(adjusted, direction);
            distance++;
        }
        return false;
    };
    terrainInDirection = (position, direction)=>{
        const range = this.state.characterWithInitiative().archetype.combatDistance;
        let adjusted = {
            x: position.x,
            y: position.y
        };
        let distance = 0;
        while((0, $923ef9a621e5c599$export$58ce12eb22e52a3f).positionInBounds(adjusted) && distance <= range){
            if ((0, $923ef9a621e5c599$export$58ce12eb22e52a3f).terrainAtPosition(this.state.terrain, adjusted)) return adjusted;
            adjusted = (0, $923ef9a621e5c599$export$58ce12eb22e52a3f).adjustPosition(adjusted, direction);
            distance++;
        }
        return false;
    };
    tick() {
        // console.info('game.js - tick', this.state.characterWithInitiative().name)
        if (this.state.ended) return;
        this.state.attacks = [];
        this.identifyActions();
        if (this.state.characterWithInitiative().isAdversary) this.chooseAdversaryAction();
        this.performAction();
    }
}



class $4df8376c83a8b088$export$160ae30d75f98247 {
    static all(state) {
        if (!state) return;
        $4df8376c83a8b088$export$160ae30d75f98247.intro(state.game);
        $4df8376c83a8b088$export$160ae30d75f98247.settings(state.game);
        if (state && state.game && state.game.state) {
            $4df8376c83a8b088$export$160ae30d75f98247.outro(state.game.state);
            if (state.game.state.log) $4df8376c83a8b088$export$160ae30d75f98247.log(state.game.state);
            if (state.game.state.map && state.game.state.map.board) {
                $4df8376c83a8b088$export$160ae30d75f98247.board(state.game.state.map.board, state.game.state.map.actions);
                if (state.game.state.adversaries && state.game.state.partiers) {
                    // attacks coming before characters ensures that the attacks are visible in the cell
                    // they replace the character by pushing it below the bottom of the viewport
                    // which is something that could be improved eventually so the attacks are on top of the characters
                    $4df8376c83a8b088$export$160ae30d75f98247.attacks(state.game.state.attacks);
                    $4df8376c83a8b088$export$160ae30d75f98247.characters(state.game.state);
                    $4df8376c83a8b088$export$160ae30d75f98247.initiative(state.game.state);
                    $4df8376c83a8b088$export$160ae30d75f98247.detail(state.game.state.characterWithInitiative());
                }
            }
        }
    }
    static attacks(attacks) {
        if (attacks.length < 1) return;
        attacks.forEach((attack, index)=>{
            const targetCell = document.getElementById($4df8376c83a8b088$export$160ae30d75f98247.cellId(attack.target.x, attack.target.y));
            const overlay = document.createElement("div");
            overlay.classList.add('attack');
            overlay.style.backgroundImage = "var(--sprite-attack)";
            overlay.style.backgroundSize = "cover";
            overlay.style.zIndex = "1000";
            targetCell.appendChild(overlay);
        });
    }
    static board(board, actions) {
        // console.info('Render.js - rendering board', board)
        // console.info('Render.js - rendering board', board[0][10])
        const containerLeftTop = document.getElementById("container-left-top");
        // doing y on the outside to assemble 11 rows of 11 cells
        for(let y = 0; y < board[0].length; y++){
            const gridRowsTop = y + 2;
            const gridRowsBottom = y + 3;
            for(let x = 0; x < board.length; x++){
                const gridColumnsLeft = x + 2;
                const gridColumnsRight = x + 3;
                const oldCell = document.getElementById($4df8376c83a8b088$export$160ae30d75f98247.cellId(x, y));
                if (oldCell) {
                    const isActionable = [
                        ...actions.attack,
                        ...actions.move,
                        ...actions.rest
                    ].find((action)=>{
                        return x === action.position.x && y === action.position.y;
                    });
                    if (isActionable) oldCell.classList.remove('masked');
                    else oldCell.classList.add('masked');
                    $4df8376c83a8b088$export$160ae30d75f98247.clearChildren(oldCell);
                } else {
                    const cell = document.createElement("div");
                    cell.id = $4df8376c83a8b088$export$160ae30d75f98247.cellId(x, y);
                    cell.style.gridTemplateColumns = `${gridColumnsLeft} / ${gridColumnsRight}`;
                    cell.style.gridTemplateRows = `${gridRowsTop} / ${gridRowsBottom}`;
                    cell.classList.add('terrain');
                    switch(board[y][x]){
                        case 0, $3011993b820701fd$export$19232cf1de8b5126:
                            cell.classList.add('terrain-tree');
                            break;
                        case 0, $3011993b820701fd$export$7c645dd5a0f2fa39:
                            cell.classList.add('terrain-rock');
                            break;
                        case 0, $3011993b820701fd$export$a5dd25a4ddf1d32e:
                            cell.classList.add('terrain-water');
                            break;
                        case 0, $3011993b820701fd$export$1e8f39e249d92158:
                            cell.classList.add('terrain-plain');
                            break;
                    }
                    containerLeftTop.appendChild(cell);
                }
            }
        }
    }
    static cellId(x, y) {
        return `${(x + "").padStart(2, "0")}-${(y + "").padStart(2, "0")}`;
    }
    static characters(state) {
        // console.info('Render.js - rendering characters', state)
        const characters = state.allCharacters();
        characters.forEach((character)=>{
            if (!character.isAlive()) return;
            const containingCell = document.getElementById($4df8376c83a8b088$export$160ae30d75f98247.cellId(character.position.x, character.position.y));
            const renderedCharacter = document.createElement('div');
            renderedCharacter.style.backgroundImage = `var(--${character.archetype.cssImageVariable})`;
            renderedCharacter.style.backgroundRepeat = 'none';
            renderedCharacter.classList.add('character');
            if (character.isAdversary) renderedCharacter.classList.add('adversary');
            else renderedCharacter.classList.add('partier');
            if (character.number === state.characterWithInitiative().number) renderedCharacter.classList.add('active');
            containingCell.appendChild(renderedCharacter);
        });
    }
    static clearChildren(node) {
        if (!node) return;
        while(node.lastElementChild)node.removeChild(node.lastElementChild);
    }
    static detail(character) {
        if (!character) return;
        document.getElementById('content-pane-detail-character-name').innerText = character.name;
        document.getElementById('content-pane-detail-character-archetype').innerText = character.archetype.label;
        document.getElementById('content-pane-detail-character-position').innerText = `(${character.position.x},${character.position.y})`;
        const health = document.getElementById('content-pane-detail-character-health');
        if (character.isAdversary) health.innerText = character.obfuscatedHealth();
        else health.innerText = `(${character.health} / ${character.maxHealth})`;
    }
    static initiative(state) {
        const contentPaneInitiativeTable = document.getElementById('content-pane-initiative-table');
        $4df8376c83a8b088$export$160ae30d75f98247.clearChildren(contentPaneInitiativeTable);
        const initiative = state.initiative;
        initiative.order.forEach((initChar)=>{
            const character = state.characterWithNumber(initChar.number);
            const nameCell = document.createElement('td');
            nameCell.innerText = character.name;
            const conditionCell = document.createElement('td');
            conditionCell.innerText = character.obfuscatedHealth();
            const row = document.createElement('tr');
            row.appendChild(nameCell);
            row.appendChild(conditionCell);
            if (character.isAdversary) row.classList.add('adversary');
            else row.classList.add('partier');
            if (character.number === state.characterWithInitiative().number) row.classList.add('active');
            contentPaneInitiativeTable.appendChild(row);
        });
    }
    static intro(game) {
        // console.info('Render.js - rendering intro', game)
        const contentPanelIntro = document.getElementById('content-pane-intro');
        if (game === null) {
            if (contentPanelIntro.style.display === "block") return;
            contentPanelIntro.style.display = "block";
        } else {
            if (contentPanelIntro.style.display === "hidden") return;
            contentPanelIntro.style.display = "none";
        }
    }
    static log(state) {
        // console.info('Render.js - rendering log')
        const contentPaneLogHistoryItems = document.getElementById('content-pane-log-history-items');
        $4df8376c83a8b088$export$160ae30d75f98247.clearChildren(contentPaneLogHistoryItems);
        state.log.forEach((entry)=>{
            const item = document.createElement('div');
            item.innerText = entry;
            contentPaneLogHistoryItems.appendChild(item);
        });
        // scroll to the bottom of the container so the new item is always visible at the bottom
        contentPaneLogHistoryItems.scrollTop = contentPaneLogHistoryItems.scrollHeight;
        const input = document.getElementById('content-pane-log-command-line-input');
        // very clunky way to satisfy the need for the little animation here
        // duplicates logic in game
        // maybe move it to Utilities where they can share it? 
        const characterInOrder = state.initiative.order[state.initiative.indexWithInitiative];
        const characterWithInitiative = state.adversaries.concat(state.partiers).find((character)=>character.number === characterInOrder.number);
        input.classList.remove('spinning');
        input.classList.remove('blinking');
        switch(state.action){
            case 0, $3011993b820701fd$export$1db4dadbdda533a3:
                input.innerText = 'ATTACKING -';
                break;
            case 0, $3011993b820701fd$export$cae6d2c3c92242c8:
                input.innerText = 'MOVING -';
                break;
            default:
                if (characterWithInitiative.isAdversary) {
                    input.classList.add('spinning');
                    input.innerText = '|';
                } else {
                    input.classList.add('blinking');
                    input.innerText = '_';
                }
        }
    }
    static outro(state) {
        const contentPanelOutro = document.getElementById('content-pane-outro');
        if (state && state.ended) {
            if (contentPanelOutro.style.display === "block") return;
            contentPanelOutro.style.display = "block";
        } else {
            if (contentPanelOutro.style.display === "none") return;
            contentPanelOutro.style.display = "none";
        }
    }
    static settings(game) {
        const contentPaneSettings = document.getElementById('content-pane-settings');
        const bottomRightTopFork = document.getElementById('bottom-right-top-fork');
        const bottomRightLeftFork = document.getElementById('bottom-right-left-fork');
        const bottomRighRightFork = document.getElementById('bottom-right-right-fork');
        if (game === null) {
            // console.info('Render.js - rendering settings')
            if (contentPaneSettings.style.display === "block") return;
            bottomRightTopFork.classList.remove('border-fork-down');
            bottomRightTopFork.classList.add('border-horizontal');
            bottomRightLeftFork.classList.remove('border-fork-right');
            bottomRightLeftFork.classList.add('border-vertical');
            bottomRighRightFork.classList.remove('border-fork-left');
            bottomRighRightFork.classList.add('border-vertical');
            contentPaneSettings.style.display = "block";
        } else {
            if (contentPaneSettings.style.display === "hidden") return;
            bottomRighRightFork.classList.remove('border-vertical');
            bottomRighRightFork.classList.add('border-fork-left');
            bottomRightLeftFork.classList.remove('border-vertical');
            bottomRightLeftFork.classList.add('border-fork-right');
            bottomRightTopFork.classList.remove('border-horizontal');
            bottomRightTopFork.classList.add('border-fork-down');
            contentPaneSettings.style.display = "none";
        }
    }
}



const $5c76c9e20a521132$var$state = {
    action: null,
    direction: null,
    settings: {
        adversaries: 'random',
        partiers: 'random',
        map: 'random'
    },
    game: null
};
class $5c76c9e20a521132$var$Interface {
    constructor(){
        // console.info("Interface.js - constructing")
        this.loadMaps();
        this.handleKey = this.handleKey.bind(this);
        window.addEventListener('keyup', this.handleKey);
        this.handleMouse = this.handleMouse.bind(this);
        window.addEventListener('mouseup', this.handleMouse);
        this.handleTouch = this.handleTouch.bind(this);
        window.addEventListener('touchend', this.handleTouch);
        (0, $4df8376c83a8b088$export$160ae30d75f98247).all($5c76c9e20a521132$var$state);
    }
    decipherEvent(event) {
        if ($5c76c9e20a521132$var$state.game === null) {
            this.startGame();
            return;
        }
        if ($5c76c9e20a521132$var$state.game.state.ended) {
            this.startGame();
            return;
        }
        const cell = event.target;
        if (cell.classList.contains('masked')) return;
        let parsedId;
        if (cell.classList.contains('terrain')) parsedId = cell.id.split('-');
        else if (cell.classList.contains('character')) {
            if (cell.parentElement.classList.contains('masked')) return;
            if (cell.classList.contains('partier')) {
                $5c76c9e20a521132$var$state.game.state.action = (0, $3011993b820701fd$export$ec52a6ec7cbb37f3);
                $5c76c9e20a521132$var$state.game.state.direction = null;
                return;
            }
            parsedId = cell.parentElement.id.split('-');
        } else console.error('clicked something that wasn\'t terrain or a character');
        // do something
        const clickedPosition = {
            x: Number.parseInt(parsedId[0]),
            y: Number.parseInt(parsedId[1])
        };
        const attack = $5c76c9e20a521132$var$state.game.state.map.actions.attack.find((attack)=>{
            return attack.position.x === clickedPosition.x && attack.position.y === clickedPosition.y;
        });
        if (attack) {
            $5c76c9e20a521132$var$state.game.state.action = (0, $3011993b820701fd$export$1db4dadbdda533a3);
            $5c76c9e20a521132$var$state.game.state.direction = attack.direction;
            return;
        }
        const move = $5c76c9e20a521132$var$state.game.state.map.actions.move.find((move)=>{
            return move.position.x === clickedPosition.x && move.position.y === clickedPosition.y;
        });
        if (move) {
            $5c76c9e20a521132$var$state.game.state.action = (0, $3011993b820701fd$export$cae6d2c3c92242c8);
            $5c76c9e20a521132$var$state.game.state.direction = move.direction;
        }
    }
    endGame() {
        // console.info('Interface.js - ending game')
        const terrainCells = document.getElementsByClassName("terrain");
        while(terrainCells.length > 0)terrainCells[0].remove();
        clearInterval(this.intervalId);
        // console.log('if')
        // state.game.endGame()
        (0, $4df8376c83a8b088$export$160ae30d75f98247).all($5c76c9e20a521132$var$state);
    }
    handleKey(event) {
        event.preventDefault();
        // ignore shift, ctrl, alt, cmd (chrome, safari), cmd (firefox) 
        if ([
            16,
            17,
            18,
            91,
            224
        ].includes(event.keyCode)) return;
        // I don't like it when the game starts when I tab away so I'm putting this
        // after the meta keys. we'll see if it stays here, it's just annoying for dev.
        if ($5c76c9e20a521132$var$state.game === null) {
            this.startGame();
            return;
        }
        if ($5c76c9e20a521132$var$state.game.state.ended) {
            this.startGame();
            return;
        }
        // handle keys
        switch(event.keyCode){
            case 27:
                $5c76c9e20a521132$var$state.game.setAction(null);
                break;
            case 37:
                $5c76c9e20a521132$var$state.game.setDirection((0, $3011993b820701fd$export$4f1506fa80c37e6f));
                break;
            case 38:
                $5c76c9e20a521132$var$state.game.setDirection((0, $3011993b820701fd$export$b5ad9376033e98b2));
                break;
            case 39:
                $5c76c9e20a521132$var$state.game.setDirection((0, $3011993b820701fd$export$a34043b88230a335));
                break;
            case 40:
                $5c76c9e20a521132$var$state.game.setDirection((0, $3011993b820701fd$export$28a694fb106a7f62));
                break;
            case 65:
            case 97:
                $5c76c9e20a521132$var$state.game.setDirection(null);
                $5c76c9e20a521132$var$state.game.setAction((0, $3011993b820701fd$export$1db4dadbdda533a3));
                (0, $4df8376c83a8b088$export$160ae30d75f98247).all();
                break;
            case 77:
            case 109:
                $5c76c9e20a521132$var$state.game.setDirection(null);
                $5c76c9e20a521132$var$state.game.setAction((0, $3011993b820701fd$export$cae6d2c3c92242c8));
                (0, $4df8376c83a8b088$export$160ae30d75f98247).all();
                break;
            case 81:
            case 113:
                this.endGame();
                break;
            case 32:
            case 81:
            case 114:
            case 90:
            case 122:
                $5c76c9e20a521132$var$state.game.setDirection(null);
                $5c76c9e20a521132$var$state.game.setAction((0, $3011993b820701fd$export$ec52a6ec7cbb37f3));
                break;
            default:
                console.error(`Unbound key: ${event.keyCode}`);
        }
    }
    handleMouse(event) {
        event.preventDefault();
        return this.decipherEvent(event);
    }
    handleTouch(event) {
        event.preventDefault();
        return this.decipherEvent(event);
    }
    loadMaps() {
        (0, $75fba0346ebd585c$export$985739bfa5723e08).mapList().forEach((map)=>{
            const option = document.createElement('option');
            option.value = map.name;
            option.innerText = map.name;
            document.getElementById('content-pane-settings-map').appendChild(option);
        });
    }
    startGame() {
        $5c76c9e20a521132$var$state.settings = {
            adversaries: document.getElementById('content-pane-settings-adversaries').value,
            map: document.getElementById('content-pane-settings-map').value,
            partiers: document.getElementById('content-pane-settings-partiers').value
        };
        $5c76c9e20a521132$var$state.game = new (0, $75fba0346ebd585c$export$985739bfa5723e08)($5c76c9e20a521132$var$state.settings);
        this.intervalId = setInterval(()=>{
            this.tick();
        }, 250);
    }
    tick() {
        if ($5c76c9e20a521132$var$state.game.state.ended) {
            const h1 = document.getElementById('content-pane-outro-header');
            if ($5c76c9e20a521132$var$state.game.state.allPartiersAreDead()) h1.innerText = 'Adversaries Win!';
            else h1.innerText = 'Partiers Win!';
            this.endGame();
        }
        $5c76c9e20a521132$var$state.game.tick();
        (0, $4df8376c83a8b088$export$160ae30d75f98247).all($5c76c9e20a521132$var$state);
    }
}
window.addEventListener("DOMContentLoaded", ()=>new $5c76c9e20a521132$var$Interface());


//# sourceMappingURL=combat-exclamation-point-colon-the-game.3bf6c74e.js.map
